import clsx from 'clsx';

import CheckmarkCircle from '~/shared/assets/icons/checkmark-circle.svg';

export function CopiedTooltip() {
  return (
    <div
      className={clsx([
        'flex items-center gap-1 text-xs absolute left-full bg-white text-green p-4 border-2 border-primary-50 rounded-sm',
        'transition duration-300 ease-in-out translate-x-2',
        'before:bg-white before:absolute before:h-2 before:w-2 before:rotate-45 before:left-[-4px] border-2 border-primary-50',
      ])}
    >
      <CheckmarkCircle className="w-[16px] h-[16px] stroke-current-color" />
      Copied
    </div>
  );
}
